function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.6613 12.2933C20.4762 11.9095 21.2576 11.4663 22 10.9694V8.49121C19.2608 10.687 15.7838 12.0005 12 12.0005C8.21621 12.0005 4.7392 10.687 2 8.49121V10.9694C2.7424 11.4663 3.52383 11.9095 4.33872 12.2933L2.83147 16.0239L4.68584 16.7731L6.19284 13.0432C7.04081 13.332 7.91724 13.5594 8.81682 13.7199L8.32633 17.7146L10.3114 17.9584L10.8022 13.9612C11.1981 13.9873 11.5975 14.0005 12 14.0005C12.4025 14.0005 12.8019 13.9873 13.1978 13.9612L13.6886 17.9584L15.6737 17.7146L15.1832 13.7199C16.0828 13.5594 16.9592 13.332 17.8072 13.0432L19.3142 16.7731L21.1685 16.0239L19.6613 12.2933Z",
  fill: "black"
});

var SvgVisibilityOff = function SvgVisibilityOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisibilityOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visibility_off.b7dbee4e.svg";
export { ForwardRef as ReactComponent };